// extracted by mini-css-extract-plugin
export var copyable = "_n-1";
export var explainable = "_n-0";
export var negative = "_n-2";
export var positive = "_n-3";